import styled from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
  min-height: 280px;
`;

export const CartProductsEmpty = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  text-align: center;
  line-height: 1.5;
  margin: 48px auto 0;
  max-width: 260px;
`;
